export enum MultiPlanFeatureFlag {
  MultiPlanProtectionDetails = 'multi-plan-protection-details',
}
